import React, { FunctionComponent } from 'react';

export interface CommentIconProps {
  label: string;
  color: string;
}

const CommentIcon: FunctionComponent<CommentIconProps> = ({ label, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      aria-label={label}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.34375C0 1.25644 0.881439 0.375 1.96875 0.375H10.0312C11.1186 0.375 12 1.25644 12 2.34375V8.53125C12 9.61856 11.1186 10.5 10.0312 10.5H3.33688L0.841578 11.9259C0.667483 12.0254 0.453593 12.0247 0.280166 11.924C0.106739 11.8234 0 11.638 0 11.4375V2.34375ZM1.96875 1.5C1.50276 1.5 1.125 1.87776 1.125 2.34375V10.4682L3.03812 9.375H10.0312C10.4972 9.375 10.875 8.99724 10.875 8.53125V2.34375C10.875 1.87776 10.4972 1.5 10.0312 1.5H1.96875ZM9.00018 4.87486H3.00018V3.74986H9.00018V4.87486ZM6.75018 7.12486H3.00018V5.99986H6.75018V7.12486Z"
        fill={color}
      />
    </svg>
  );
};

export default CommentIcon;
